import React from "react";
import { Link } from "react-router-dom";

import "./homeCta.css";

const HomeCta = () => {
  return (
    <section className="home-cta" aria-label="Start learning">
      <div className="container">
        <div className="home-cta-content">
          <div>
            <p className="home-cta-eyebrow">Your next step starts here</p>
            <h2>Ready to learn something new?</h2>
            <p>Choose a course that matches your goals and start building skills that move you forward.</p>
          </div>
          <div className="home-cta-actions">
            <Link to="/courses" className="theme-btn">Explore courses</Link>
            <Link to="/contact" className="home-cta-link">Talk to us</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeCta;
